var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"flex-column d-flex m-0 p-0"},[_c('site-summary')],1)}
var staticRenderFns = []

export { render, staticRenderFns }